/**
 * Validates a post-login return path (e.g. `/login?redirect=…`) so it can
 * only point back into this app: a same-origin absolute path, never a
 * protocol-relative or backslash-smuggled URL (open-redirect guard), and
 * never the login page itself (a loop).
 */
export function safeRedirectPath(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const path = value.trim();
  if (!path.startsWith("/")) return undefined;
  // `//host` and `/\host` are treated by browsers as another origin.
  if (path.startsWith("//") || path.startsWith("/\\")) return undefined;
  // Control characters (tab/newline) are stripped by URL parsers, which can
  // turn an innocent-looking path back into `//host`.
  // eslint-disable-next-line no-control-regex -- rejecting control characters is the point
  if (/[\u0000-\u001f\u007f]/.test(path)) return undefined;
  if (
    path === "/login" ||
    path.startsWith("/login?") ||
    path.startsWith("/login/")
  ) {
    return undefined;
  }
  return path;
}
